import React from 'react'

import { Route } from 'react-router-dom'

import { withCubeReportsLayout } from 'layouts/CubeReportsLayout'
import RoutingReportV2 from 'pages/routing/RoutingReportV2'
import { ReportPage } from 'types/pages'

const RoutingReport = () => {
  return (
    <>
      <Route exact path="/routing">
        <RoutingReportV2 />
      </Route>
    </>
  )
}

export default withCubeReportsLayout(
  ReportPage.Routing,
  true,
  true
)(RoutingReport)
